(function(){
  const root=()=>document.scrollingElement||document.documentElement;
  function jump(){root().scrollTop=0;document.body.scrollTop=0}
  document.addEventListener('click',e=>{
    let btn=e.target.closest('.scroll-antlnhjkop');
    if(!btn)return;
    if(btn.tagName==='A')e.preventDefault();
    jump();
  },true);
})();

document.addEventListener('DOMContentLoaded',()=>{
  let nav=document.getElementById('NavDrawer');
  let btn=document.querySelector('.js-drawer-open-nav.scroll-antlnhjkop');
  if(!nav||!btn)return;
  let img=btn.querySelector('img');
  let openSrc='https://cdn.shopify.com/s/files/1/0947/3553/2378/files/Vector_9.svg?v=1753375373';
  let closeSrc='https://cdn.shopify.com/s/files/1/0947/3553/2378/files/close.svg?v=1753403914';
  let sync=()=>{img.src=nav.classList.contains('drawer--is-open')?closeSrc:openSrc};
  new MutationObserver(sync).observe(nav,{attributes:true,attributeFilter:['class']});
  sync();
});




// document.addEventListener("DOMContentLoaded", function() {
//   if (window.location.pathname === "/cart") {
//     var interval = setInterval(function() {
//       var btn = document.querySelector('button[name="checkout"].button-cartX');
//       if (btn) {
       
//         ['mousedown','mouseup','click'].forEach(function(ev){
//           btn.dispatchEvent(new MouseEvent(ev, {
//             view: window,
//             bubbles: true,
//             cancelable: true
//           }));
//         });
        
//       }
//     }, 2000); 
//   }
// });